var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 10 12",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m88.7915097 581.208318c.3988395.774472.1595358 1.006813-.5982593.580854l-8.7744689-5.188957c-.5583753-.348512-.5583753-.890642 0-1.20043l8.7744689-5.188957c.7577951-.425959 1.0369827-.193618.5982593.580854l-.2393037.425959c-1.4358222 2.633202-1.4358222 6.931516 0 9.603442z",
    fill: "#003DA5",
    transform: "matrix(-1 0 0 -1 89 582)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.469c2ae72d1d87b7c44cec7bd57972da.svg";
export { ForwardRef as ReactComponent };